import { render } from "./TheRechargesV2Container.vue?vue&type=template&id=01d8d5a4"
import script from "./TheRechargesV2Container.vue?vue&type=script&lang=js"
export * from "./TheRechargesV2Container.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__